module.exports = __webpack_public_path__ + "img/box_head.aee65137.jpg";